import React, { useState } from 'react';
import styled from 'styled-components';
import hasHoc from 'util/hoc/has-hoc';
import { removeUsersFromProfessionalCenterGroup } from 'apps/journey/pages/professional-center/queries/user-groups';
import { NotificationRender } from 'library/components/notification';
import { pluralize } from 'library/helpers/text';
import { ActionButton } from 'apps/journey/pages/professional-center/components/action-button';
import { RemoveFromGroup, Alert } from 'library/icons';
import ConfirmationModal from 'apps/journey/components/modals/confirmation-modal';
import { Header5 } from 'library/components/text-elements/headings';
import { BodyText } from 'library/components/text-elements/text';

const StyledExitGroup = styled(RemoveFromGroup)`
  font-size: 1.25em;
`;

const StyledConfirmWrapper = styled.div`
  max-width: 350px;
  p {
    font-size: 16px;
  }
  h5 {
    font-size: 22px;
  }
`;

const RemoveFromGroupsButton = ({
  uuids,
  nodeId,
  reloadTable,
  buttonText = 'Remove From Group',
}) => {
  const [loading, setLoading] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);

  const removeUserFromGroups = async () => {
    setLoading(true);
    const { success, users } = await removeUsersFromProfessionalCenterGroup({
      uuids,
      nodeId,
    });
    if (success) {
      NotificationRender(
        'success',
        `You have successfully removed ${pluralize(
          'individual',
          users.length,
          true
        )}.`
      );
      setConfirmModal(false);
      await reloadTable(uuids);
    } else {
      NotificationRender(
        'info',
        'There was an error removing your selected individuals'
      );
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <ActionButton
        iconComponent={StyledExitGroup}
        onClick={() => setConfirmModal(true)}
        disabled={loading}
      >
        {buttonText}
      </ActionButton>
      <ConfirmationModal
        cancelText="Cancel"
        confirmText="Confirm"
        toggleActive={() => setConfirmModal(false)}
        handleSubmit={removeUserFromGroups}
        active={confirmModal}
        customIcon={<Alert width={24} height={24} />}
        customColor="#fec821"
      >
        <StyledConfirmWrapper>
          <Header5>Are you sure?</Header5>
          <BodyText>
            The selected user{uuids.length > 1 ? 's' : ''} will be removed from
            this organization.
          </BodyText>
        </StyledConfirmWrapper>
      </ConfirmationModal>
    </React.Fragment>
  );
};

RemoveFromGroupsButton.requiredPermissions = ({ nodeId }) => {
  return {
    [nodeId]: ['ProfessionalAdmin', 'ProfessionalSuperAdmin'],
  };
};

const RemoveFromGroupsButtonWithHOC = hasHoc(RemoveFromGroupsButton, [
  'requiresPermission',
]);

export default RemoveFromGroupsButton;
export { RemoveFromGroupsButtonWithHOC };
